import PrivacyPolicyComp from "./components/privacy_policy_comp"
import PageComponent from "../../components/page/page_comp";
import PageV2Comp from "../../components/page_v2/page_v2_comp";
const PrivacyPolicyPage = () => {
    // return <PageComponent content={<PrivacyPolicyComp />} showFooter={false} />
    return (
        <PageV2Comp
            showFooter={false}
        >
            <PrivacyPolicyComp />
        </PageV2Comp>
    )
}

export default PrivacyPolicyPage;